import { useMemo } from 'react';

import { useMediaQuery } from '@chakra-ui/react';

import { enabledLanguages } from '@/i18n';

import { MediaQueriesEnum } from '@/enums/mediaQueries.enum';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { useLocalStorage } from './useLocalStorage';

export const useSettings = () => {
  const [isDesktop, isMobile, isTablet] = useMediaQuery(
    [
      MediaQueriesEnum.isDesktop,
      MediaQueriesEnum.isMobile,
      MediaQueriesEnum.isTablet,
    ],
    {
      ssr: false,
    },
  );
  const { value: lang } = useLocalStorage<string>(StorageKeysEnum.i18nextLng);

  const isLangSwitcherEnabled = useMemo(() => enabledLanguages.length > 1, []);

  return { isDesktop, isMobile, isTablet, isLangSwitcherEnabled, lang };
};
